import { DateUtilities } from './date.utilities';

export class FileDownloadUtilities {
  static downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }

  static getFilenameFromContentDisposition(header: string | null): string | null {
    if (!header) return null;

    const match = header.match(/filename\*?=(?:UTF-8''|"?)([^";]+)"?/i);
    return match?.[1] ? decodeURIComponent(match[1]) : null;
  }

  static buildInvoiceDataFilename(): string {
    const dateStr = DateUtilities.format(new Date()).replace(/\//g, '-');
    return `Invoice-data-${dateStr}.csv`;
  }
}
